import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-51',
  templateUrl: './cards8-examples-51.component.html'
})
export class Cards8Examples51Component {}
